/**
 * 搜索
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import { Icon } from '@ok/okd';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemSearch extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
      loading: false,
      searchList: [],
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  /**
   * 输入值变化监听
   * @param e
   */
  onChange = (e) => {
    const value = e.target.value;
    const { key, onChange, errorData, formType, extend, filter } =
      this.props.dataSource;

    const val = filter ? filter(value) : value;
    const errorMsg = this.getErrorMsg(val, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
    });
    if (onChange) {
      const ret = onChange(key, formType, val, allow, extend);
      // if return a Promise
      if (ret && ret.then) {
        this.setState({ loading: true });
        // eslint-disable-next-line promise/catch-or-return
        ret.then(
          (res) => {
            this.setState({ searchList: res });
            this.setState({ loading: false });
          },
          () => {
            this.setState({ loading: false });
          }
        );
      }
    } else {
      this.setState({ loading: false });
    }
  };

  // 搜索点击
  onSearch = () => {
    const { key, onSearch, formType, extend } = this.props.dataSource;
    onSearch && onSearch(key, formType, this.state.value, extend);
  };

  // 输入框聚焦
  onSearchInputFocus = (e) => {
    this.onFocus(e);
  };

  // 输入框失焦
  onSearchInputBlur = (e) => {
    // 需要能先触发下拉的点击，故延时清除
    this.onBlur(e, 300);
  };

  // 下拉点击
  onSelect = (e) => {
    const { searchList } = this.state;
    const { key, formType, extend, onSelect } = this.props.dataSource;
    const index = e.target.getAttribute('data-index');
    onSelect && onSelect(key, formType, searchList[index], extend);
  };

  renderSearchList = () => {
    const { focus, searchList } = this.state;
    if (!focus || !searchList || searchList.length === 0) {
      return null;
    }
    return (
      <div className="search-list">
        {searchList.map((item, index) => {
          return (
            <div
              key={`searchItem${index}`}
              data-index={index}
              className="search-item"
              onClick={this.onSelect}
            >
              {item.label}
            </div>
          );
        })}
      </div>
    );
  };

  /**
   * 渲染搜索类型
   * @returns {*}
   */
  renderFormLine() {
    const { errorMsg, value, focus } = this.state;
    const { inputAttr, tips, onSearch, bottomArea } = this.props.dataSource;

    let placeholderRight = '';

    /**
     * 默认为实时查询，需要在onChange处理
     * 有搜索点击回调,则认为是点击才查询，非实时模式
     */
    if (onSearch) {
      placeholderRight = (
        <span onClick={this.onSearch} className="icon-search">
          <Icon className="okds-search" />
        </span>
      );
    }

    const attr = {
      value,
      className: 'form-transparent-input',
      onChange: this.onChange,
      onFocus: this.onSearchInputFocus,
      onBlur: this.onSearchInputBlur,
    };

    return (
      <div className="form-input-box form-search">
        <div className="mock-input-box" data-focus={focus}>
          <div className="mock-input" />
          <input type="text" {...inputAttr} {...attr} />
          <span className="placeholder-right">{placeholderRight}</span>
        </div>
        {this.renderSearchList()}
        <span className="form-tips">{tips}</span>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLine()}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemSearch.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.SEARCH,
    inputAttr: {},
    defaultValue: '',
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
